// Dissolve: each selected point takes the class of the nearest point of another class within reach,
// searching every cloud given (scans overlap). Classes are codes shared across the clouds (by name).
import type { Grid } from '../align.ts';

export interface DissolveCloud {
  P: Float32Array;     // per vertex, world position
  grid: Grid;          // over P
  cls: Int32Array;     // per vertex, its class code
  sel: Uint8Array;     // per vertex, 1: dissolve it
  target: Uint8Array;  // per vertex, 1: may give its class (not deleted, not being dissolved)
}

/** Per cloud, per vertex: the class code a selected point takes, or -1 (not selected, or nothing of another class within reach).
 * Every point looks at the classes as they were, so the order points are visited in doesn't matter. */
export function dissolve(clouds: DissolveCloud[], reach: number): Int32Array[] {
  return clouds.map(c => {
    const out = new Int32Array(c.sel.length).fill(-1);
    for (let v = 0; v < c.sel.length; v++) {
      if (!c.sel[v]) continue;
      const own = c.cls[v], x = c.P[3 * v], y = c.P[3 * v + 1], z = c.P[3 * v + 2];
      let best = reach * reach;
      for (const o of clouds) {
        const i = o.grid.nearest(x, y, z, Math.sqrt(best), j => o.target[j] === 1 && o.cls[j] !== own);
        if (i < 0) continue;
        const d = (o.P[3 * i] - x) ** 2 + (o.P[3 * i + 1] - y) ** 2 + (o.P[3 * i + 2] - z) ** 2;
        if (d <= best) { best = d; out[v] = o.cls[i]; }
      }
    }
    return out;
  });
}
